import { useParams, Link, Navigate } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { BLOG_POSTS } from "@/data/mock";
import { ArrowLeft, Calendar, Clock } from "lucide-react";

// Simple markdown-lite renderer: **bold** and paragraphs
const renderLine = (text, i) => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return (
    <p key={i} className="text-slate-700 leading-relaxed mb-4">
      {parts.map((p, j) => p.startsWith("**") && p.endsWith("**") ? <strong key={j} className="font-bold text-slate-900">{p.slice(2, -2)}</strong> : <span key={j}>{p}</span>)}
    </p>
  );
};

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;

  return (
    <PageLayout>
      <article className="pt-28 lg:pt-32 pb-16 bg-white">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8">
          <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-600 hover:text-sky-700 mb-6" data-testid="blog-back-btn">
            <ArrowLeft className="w-4 h-4" /> Back to blog
          </Link>
          <span className="inline-block text-xs font-bold text-sky-600 uppercase tracking-wider mb-3">{post.category}</span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-4 leading-tight">
            {post.title}
          </h1>
          <div className="flex items-center gap-4 text-sm text-slate-400 mb-6">
            <span className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {post.date}</span>
            <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {post.readTime}</span>
          </div>
          <div className="aspect-[16/9] overflow-hidden rounded-3xl bg-slate-100 mb-8">
            <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
          </div>
          <div className="prose prose-slate max-w-none">
            {post.body.map(renderLine)}
          </div>
        </div>
      </article>
    </PageLayout>
  );
}
